import PageHero from "@/components/PageHero";
import SEO from "@/components/SEO";
import { useTranslation } from "react-i18next";
import SecurityBand from "@/components/home/SecurityBand";
import WaitlistCTA from "@/components/home/WaitlistCTA";
import { ShieldCheck, KeyRound, EyeOff, FileCheck2, Scale, Lock } from "lucide-react";

const CONTROL_ICONS = [KeyRound, EyeOff, ShieldCheck, FileCheck2, Scale, Lock];

export default function Security() {
  const { t } = useTranslation();
  const CONTROLS = (t("content.security.controls", { returnObjects: true }) || []).map((c, i) => ({
    icon: CONTROL_ICONS[i] || ShieldCheck,
    title: c.title,
    body: c.body,
  }));
  return (
    <>
      <SEO
        slug="security"
        title="Security · Regulated, not renegade — Instantxfer CashApp"
        description="Key-vaulted, device-bound, zero-knowledge sync, 3-D fraud engine, immutable audit trails, licensed money-service partners in every corridor."
      />
      <PageHero
        eyebrow={t("pageHero.security.eyebrow")}
        title={t("pageHero.security.title")}
        italic={t("pageHero.security.italic")}
        body={t("pageHero.security.body")}
        testId="security-hero"
      />

      <section className="pb-24 md:pb-32 bg-canvas">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {CONTROLS.map((c, i) => (
            <div key={c.title} className="card-flat p-8 md:p-10" data-testid={`security-control-${i}`}>
              <div className="w-12 h-12 rounded-full bg-forest text-canvas grid place-items-center">
                <c.icon className="w-5 h-5" strokeWidth={1.75} />
              </div>
              <h3 className="mt-6 font-display font-medium text-2xl md:text-3xl tracking-tight text-forest">
                {c.title}
              </h3>
              <p className="mt-3 text-ink/70 leading-relaxed">{c.body}</p>
            </div>
          ))}
        </div>
      </section>

      <SecurityBand />

      <section className="py-24 bg-surface">
        <div className="container-x grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
          <div className="md:col-span-4">
            <div className="label-eyebrow">Report a concern</div>
            <h2 className="mt-3 font-display font-medium text-forest text-3xl md:text-4xl tracking-tightest">
              We answer, every time.
            </h2>
          </div>
          <div className="md:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-4">
            {[
              { title: "Vulnerabilities", body: "security@instantxfer.com" },
              { title: "Suspicious activity", body: "watch@instantxfer.com" },
              { title: "General support", body: "support@instantxfer.com" },
            ].map((x) => (
              <div key={x.title} className="card-flat p-6">
                <div className="label-eyebrow">{x.title}</div>
                <a href={`mailto:${x.body}`} className="mt-2 block font-display text-forest text-lg link-reveal">
                  {x.body}
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <WaitlistCTA />
    </>
  );
}
